import { Component, OnInit } from '@angular/core';
import { ApiService } from './services/api.service';
import { UtilitiesService } from './utilities/utilities.service';
import { FirebaseNotificationService } from './services/firebase-notification.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit{
  title = 'Demo';

  constructor(
    private permissionAPI: ApiService,
    private util: UtilitiesService,
    private firebaseNotificationService: FirebaseNotificationService
  ) { }

  ngOnInit(){
    if(sessionStorage.length === 0 ){
      sessionStorage.setItem('companyId', sessionStorage.getItem('companyId'));
    }
    const token = sessionStorage.getItem('token');
    if (token && token !== 'undefined' && token !== 'null') {
      this.permissionAPI.permissionDetails().subscribe((data) => {
        if (data.status === 'success') {
          this.util.setPermissionRoleInfo(data.data);
        }
      });
    }
    
    this.firebaseNotificationService.requestPermission();
  }

}
